// extracted by mini-css-extract-plugin
export default {"nav-item":"nav-item--zmPy5","navItem":"nav-item--zmPy5","title":"title--hp4fS","nav-item--active":"nav-item--active--Gj7V+","navItemActive":"nav-item--active--Gj7V+"};